import { ReactNode } from 'react';

import { useFieldContext } from '#form';

import { ToggleInput } from './ToggleInput';

interface InputProps {
	label: ReactNode;
	trueText?: string;
	falseText?: string;
	flip?: true;
}

export function BooleanInput({
	label,
	trueText = 'Yes',
	falseText = 'No',
	flip,
}: InputProps) {
	const field = useFieldContext<boolean | null | undefined>();

	const options =
		flip ?
			{ [falseText]: false, [trueText]: true }
		:	{ [trueText]: true, [falseText]: false };
	return (
		<ToggleInput label={label} field={field} exclusive options={options} />
	);
}
